/* istanbul ignore file */
import { UpdatePageLayout } from 'framework/ui/layout';
import { UpdateForm } from 'framework/form';
import BudgetForm from 'domain/finance/budget/createupdate/BudgetForm';
import BudgetEntityHeader from 'domain/finance/budget/shared/BudgetEntityHeader';
import UpdateBudgetBreadcrumbs from 'domain/finance/budget/createupdate/Update/Breadcrumbs';
import { useBudgetService } from 'domain/shared/budget';
import { useBudgetUrl } from 'domain/shared/budget';

const UpdateBudget = () => {
  const { update, getById, getValidationSchema } = useBudgetService();
  const { getSingleEntityUrl } = useBudgetUrl();

  return (
    <UpdateForm
      submitFormFunc={update}
      getDataFunc={getById}
      getValidationSchemaFunc={getValidationSchema}
      afterSubmit={{
        redirect: getSingleEntityUrl(),
        message: 'You are awesome! The Budget has been successfully updated.',
      }}
    >
      <UpdatePageLayout
        title="Edit: Budget"
        breadcrumbs={<UpdateBudgetBreadcrumbs />}
        entityHeader={<BudgetEntityHeader />}
      >
        <BudgetForm />
      </UpdatePageLayout>
    </UpdateForm>
  );
};

export default UpdateBudget;
